<template>
  <div>
    <b-row>
      <b-col
        lg="6"
        md="12"
        sm="12"
        class="mb-1"
      >
        <b-card
          no-body
          style="background-color: rgb(255, 127, 96, 0.0); width: 100% ;height: auto; border: 2px solid #00B058; border-radius: 4px 40px 4px 40px;"
        >
          <b-row>
            <b-col
              lg="8"
              class="d-flex align-items-center justify-content-start"
            >
              <b-img
                height="25"
                class="ml-1"
                src="@/assets/images/icons/CDroad/Graph2.svg"
              />
              <span
                class="ml-1"
                style="color:white; font-size: 16px;"
              >สถานะการทำงานโคมไฟล่าสุด</span>
            </b-col>
            <b-col
              lg="4"
              class="d-flex align-items-center justify-content-end"
            >
              <b-button
                v-b-modal="'modalSLT'"
                title="รายละเอียดแต่ละเสา"
                variant="primary"
                class="btn-icon mr-1 mt-1"
              >
                <feather-icon icon="ArchiveIcon" />
              </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
            >
              <AppEchartBar
                style="width:90%"
                :option-data="option"
              />
            </b-col>
          </b-row>

        </b-card>
      </b-col>
      <b-col
        lg="6"
        md="12"
        sm="12"
        class="mb-1"
      >
        <b-row>
          <b-col
            lg="12"
            md="12"
            sm="12"
            class="mb-1"
          >
            <b-img
              height="25"
              src="@/assets/images/icons/light4.svg"
              class="mt-1 mr-1 mb-1"
            />
            <span style="color:white; font-size: 16px;">สถานะค่าพารามิเตอร์ทางไฟฟ้าตู้ควบคุมไฟฟ้าแสงสว่างระบบ 3 เฟส</span>
            <!-- <button
              v-for="index in 1"
              id="toggle-btn"
              :key="index"
              class="round-button mr-1"
              :style="{'background-color': activeButton === index + 1 ? color : '#515151'}"
              @click="setActive(index)"
            >
              <b>{{ index }}</b>
            </button> -->
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="4"
            class="mb-1"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 155 255"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.5 238.478L12.0622 252.5H140.142H152.5V240.574V220.072V177.203V130.606V88.9802V31.6157V16.5264L142.618 2.5H2.5V18.1935V43.7003V223.384V238.478Z"
                stroke="#00B058"
              />
              <path
                d="M29 253H13.7773L2 237.51V220"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M124 2H140.35L153 16.551V33"
                stroke="#00B058"
                stroke-width="4"
              />
              <foreignObject
                x="35"
                y="5"
                width="100%"
                height="150"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  L1
                </div>
              </foreignObject>
              <foreignObject
                x="10"
                y="5"
                width="300"
                height="150"
              >
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.125 0.130411L0.407355 14.1589C0.360082 14.227 0.334444 14.3047 0.333066 14.3843C0.331688 14.4638 0.35462 14.5423 0.399513 14.6115C0.444405 14.6808 0.509646 14.7385 0.588558 14.7786C0.667469 14.8188 0.757216 14.8399 0.84861 14.8399H5.43566C5.77799 14.8399 6.05475 15.0818 6.05475 15.3788V25.7301C6.05475 26.001 6.46599 26.1016 6.62827 25.8694L16.7138 11.4878C16.7421 11.447 16.7574 11.4003 16.7582 11.3526C16.759 11.3048 16.7453 11.2578 16.7184 11.2162C16.6915 11.1746 16.6525 11.1399 16.6052 11.1158C16.5579 11.0916 16.5041 11.0788 16.4492 11.0786H11.2153C11.0785 11.0786 10.9474 11.0313 10.8506 10.9472C10.7539 10.863 10.6996 10.7488 10.6996 10.6297V0.269718C10.6996 -0.00309229 10.2872 -0.102736 10.125 0.130411Z"
                    fill="url(#paint0_radial_470_32568)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_470_32568"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.863 4.85622) rotate(96.3251) scale(16.9131 7.08258)"
                    >
                      <stop stop-color="#FFDB5E" />
                      <stop
                        offset="1"
                        stop-color="#FFB54B"
                      />
                    </radialGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="15"
                y="40"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Volt
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="40"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[0].volt }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="70"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Amp
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="70"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[0].amp }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="100"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Watt
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="100"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[0].watt }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="130"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Pf
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="130"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[0].pf }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="160"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  kWh
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="160"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[0].kwh }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="190"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Hz
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="190"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[0].hz }}
                </div>
              </foreignObject>
            </svg>
          </b-col>
          <b-col
            cols="4"
            class="mb-1"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 155 255"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.5 238.478L12.0622 252.5H140.142H152.5V240.574V220.072V177.203V130.606V88.9802V31.6157V16.5264L142.618 2.5H2.5V18.1935V43.7003V223.384V238.478Z"
                stroke="#00B058"
              />
              <path
                d="M29 253H13.7773L2 237.51V220"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M124 2H140.35L153 16.551V33"
                stroke="#00B058"
                stroke-width="4"
              />
              <foreignObject
                x="35"
                y="5"
                width="100%"
                height="150"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  L2
                </div>
              </foreignObject>
              <foreignObject
                x="10"
                y="5"
                width="300"
                height="150"
              >
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.125 0.130411L0.407355 14.1589C0.360082 14.227 0.334444 14.3047 0.333066 14.3843C0.331688 14.4638 0.35462 14.5423 0.399513 14.6115C0.444405 14.6808 0.509646 14.7385 0.588558 14.7786C0.667469 14.8188 0.757216 14.8399 0.84861 14.8399H5.43566C5.77799 14.8399 6.05475 15.0818 6.05475 15.3788V25.7301C6.05475 26.001 6.46599 26.1016 6.62827 25.8694L16.7138 11.4878C16.7421 11.447 16.7574 11.4003 16.7582 11.3526C16.759 11.3048 16.7453 11.2578 16.7184 11.2162C16.6915 11.1746 16.6525 11.1399 16.6052 11.1158C16.5579 11.0916 16.5041 11.0788 16.4492 11.0786H11.2153C11.0785 11.0786 10.9474 11.0313 10.8506 10.9472C10.7539 10.863 10.6996 10.7488 10.6996 10.6297V0.269718C10.6996 -0.00309229 10.2872 -0.102736 10.125 0.130411Z"
                    fill="url(#paint0_radial_470_32568)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_470_32568"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.863 4.85622) rotate(96.3251) scale(16.9131 7.08258)"
                    >
                      <stop stop-color="#FFDB5E" />
                      <stop
                        offset="1"
                        stop-color="#FFB54B"
                      />
                    </radialGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="15"
                y="40"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Volt
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="40"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[1].volt }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="70"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Amp
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="70"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[1].amp }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="100"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Watt
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="100"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[1].watt }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="130"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Pf
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="130"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[1].pf }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="160"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  kWh
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="160"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[1].kwh }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="190"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Hz
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="190"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[1].hz }}
                </div>
              </foreignObject>
            </svg>
          </b-col>
          <b-col
            cols="4"
            class="mb-1"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 155 255"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.5 238.478L12.0622 252.5H140.142H152.5V240.574V220.072V177.203V130.606V88.9802V31.6157V16.5264L142.618 2.5H2.5V18.1935V43.7003V223.384V238.478Z"
                stroke="#00B058"
              />
              <path
                d="M29 253H13.7773L2 237.51V220"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M124 2H140.35L153 16.551V33"
                stroke="#00B058"
                stroke-width="4"
              />
              <foreignObject
                x="35"
                y="5"
                width="100%"
                height="150"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  L3
                </div>
              </foreignObject>
              <foreignObject
                x="10"
                y="5"
                width="300"
                height="150"
              >
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.125 0.130411L0.407355 14.1589C0.360082 14.227 0.334444 14.3047 0.333066 14.3843C0.331688 14.4638 0.35462 14.5423 0.399513 14.6115C0.444405 14.6808 0.509646 14.7385 0.588558 14.7786C0.667469 14.8188 0.757216 14.8399 0.84861 14.8399H5.43566C5.77799 14.8399 6.05475 15.0818 6.05475 15.3788V25.7301C6.05475 26.001 6.46599 26.1016 6.62827 25.8694L16.7138 11.4878C16.7421 11.447 16.7574 11.4003 16.7582 11.3526C16.759 11.3048 16.7453 11.2578 16.7184 11.2162C16.6915 11.1746 16.6525 11.1399 16.6052 11.1158C16.5579 11.0916 16.5041 11.0788 16.4492 11.0786H11.2153C11.0785 11.0786 10.9474 11.0313 10.8506 10.9472C10.7539 10.863 10.6996 10.7488 10.6996 10.6297V0.269718C10.6996 -0.00309229 10.2872 -0.102736 10.125 0.130411Z"
                    fill="url(#paint0_radial_470_32568)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial_470_32568"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.863 4.85622) rotate(96.3251) scale(16.9131 7.08258)"
                    >
                      <stop stop-color="#FFDB5E" />
                      <stop
                        offset="1"
                        stop-color="#FFB54B"
                      />
                    </radialGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="15"
                y="40"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Volt
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="40"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[2].volt }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="70"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Amp
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="70"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[2].amp }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="100"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Watt
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="100"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[2].watt }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="130"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Pf
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="130"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[2].pf }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="160"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  kWh
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="160"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[2].kwh }}
                </div>
              </foreignObject>
              <foreignObject
                x="15"
                y="190"
                width="100%"
                height="150"
                color="#FFFFD5"
                font-size="14"
              >
                <div>
                  Hz
                </div>
              </foreignObject>
              <foreignObject
                x="70"
                y="190"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="15"
              >
                <div>
                  {{ items[2].hz }}
                </div>
              </foreignObject>
            </svg>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <ModalStatusLighting />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BButton, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEchartBar from './AppEchartBar.vue'
import ModalStatusLighting from './ModalStatusLighting.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BButton,
    BCard,
    AppEchartBar,
    ModalStatusLighting,
  },
  data() {
    return {
      statisticTitle: '',
      Total: '',
      color: '#00B058',
      items: [],
      activeButton: 0,
      option: {
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        grid: {
          width: '90%',
          height: '70%',
        },
        series: [
          {
            name: 'ใช้งานไม่ได้',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '40px',
            itemStyle: {
              barBorderRadius: [0, 0, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#989898' },
                { offset: 1, color: '#616161' },
              ]),
            },
          },
          {
            name: 'ใช้งานได้',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '40px',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFDB5E' },
                { offset: 1, color: '#FFB54B' },
              ]),
            },
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.setActive(1)
    this.getbarChartCounting()
    this.getMarkerSem()()
    setInterval(this.getNow, 1000)
    this.interval = setInterval(() => {
      this.getbarChartCounting()
      this.getMarkerSem()
    }, 300000)
  },
  mounted() {
  },
  methods: {
    getMarkerSem() {
      axios
        .post('/markerSEMControl', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    setActive(index) {
      this.activeButton = index + 1
    },
    getbarChartCounting() {
      axios
        .post('/graphSEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.option.xAxis[0].data.push(value.date_time)
            this.option.series[0].data.push(value.fail)
            this.option.series[1].data.push(value.work)
          })
          console.log(this.option)
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scpoed>
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  .round-button {
  min-width: 50px;
  height: 50px;
  border-style: none;
  border-radius: 50%;
  text-align: center;
  padding: 0;
  color: white;
  line-height: 20px; // to center text vertically
}
  </style>
